import {
  Collapse,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";

import conf from "config-dlm";
import ErrorChip from "components/utils/ErrorChip";
import JsonModal from "components/utils/Json";
import VirtualChip from "components/utils/VirtualChip";
import { isFound } from "components/utils/SmartCell";
import { Snapshot, ProjectConfigSchema } from "hooks/pavm/base";

// const Row = (props: { row: ReturnType<typeof createData> }) => {
const HSMRow = (props: {
  open: boolean;
  data: Snapshot["hsm"];
  config: ProjectConfigSchema;
}) => {
  const { open, config, data } = props;

  const host = config.host;
  const virtual = config.hardware === "virtual";
  const temperature = data?.data?.core?.temperature;
  const TemperatureChip = virtual ? VirtualChip(temperature) : temperature;

  return (
    <TableRow
      sx={{
        bgcolor: (theme) =>
          theme.palette.mode === "light" ? "primary.light" : "primary.dark",
        "&:last-child td": { border: 0 },
      }}
    >
      <TableCell colSpan={10}>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <Table size="small" aria-label="purchases">
            <TableHead>
              <TableRow>
                <TableCell sx={{ color: "text.secondary" }}>
                  <b>HSM</b>
                </TableCell>
                {conf.COLUMNS.HSM.map((column: string) => (
                  <TableCell key={column} align="right">
                    <b>{column}</b>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {isFound(data.data) ? (
                <TableRow key={host} sx={conf.LAST_CHILD_NO_BORDER}>
                  <TableCell />
                  <TableCell component="th" scope="row" align="right">
                    {data?.data?.core?.serialNumber ?? "--"}
                  </TableCell>
                  <TableCell align="right">
                    {data?.data?.core?.vendor ?? "--"}
                  </TableCell>
                  <TableCell align="right">
                    {data?.data?.core?.model ?? "--"}
                  </TableCell>
                  <TableCell align="right">{TemperatureChip}</TableCell>
                  <TableCell align="right">
                    {data?.data?.core?.adapterClock ?? "--"}
                  </TableCell>
                  <TableCell align="right">
                    {data?.data?.core?.firmwareVersion ?? "--"}
                  </TableCell>
                  <TableCell align="right">
                    {data?.data?.raw ? (
                      <JsonModal
                        data={data?.data?.raw}
                        type="HSM"
                        title={host}
                      />
                    ) : (
                      "--"
                    )}
                  </TableCell>
                </TableRow>
              ) : (
                <TableRow
                  key={`${host}-hsm-empty`}
                  sx={conf.LAST_CHILD_NO_BORDER}
                >
                  <TableCell>
                    <ErrorChip
                      size="small"
                      info={data?.error ?? "No data found"}
                    />
                  </TableCell>
                  {conf.COLUMNS.HSM.map((column: string) => (
                    <TableCell key={column} align="right">
                      --
                    </TableCell>
                  ))}
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Collapse>
      </TableCell>
    </TableRow>
  );
};

export default HSMRow;
